import React, { useState } from 'react';
import 'antd/dist/antd.css';
import { PlusOutlined } from '@ant-design/icons';
import { Modal, Upload } from 'antd';
import type { RcFile } from 'antd/es/upload';
import type { UploadChangeParam, UploadFile, UploadProps } from 'antd/es/upload/interface';
import styles from './style.module.scss';

/** helper: File -> base64 (プレビュー用) */
const getBase64 = (file: RcFile): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

type AppProps = {
  maxCount?: number;
  uploadText?: string;
  action?: string;
  handleChange: ((info: UploadChangeParam<UploadFile<any>>) => void) | undefined;
  props: UploadProps<any>;
  fileList?: UploadFile[];
};

const App: React.FC<AppProps> = ({
  maxCount = 1,
  uploadText = 'ファイルを選択',
  action,
  handleChange,
  props,
  fileList,
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');

  const handleCancel = () => setPreviewOpen(false);

  const handlePreview = async (file: UploadFile) => {
    let { preview } = file;
    const { url, name } = file;

    if (!url && !preview && file.originFileObj) {
      preview = await getBase64(file.originFileObj as RcFile);
    }

    setPreviewImage(url || (preview as string));
    setPreviewOpen(true);
    setPreviewTitle(name || (url ? url.substring(url.lastIndexOf('/') + 1) : ''));
  };

  const customUpload = async (options: any) => {
    const { file, onProgress, onSuccess, onError } = options;
    try {
      // uploading 状態を伝える（UI上は percent=0 の uploading）
      if (onProgress) onProgress({ percent: 0 }, file);

      // 即座に成功扱いにする
      await new Promise((res) => setTimeout(res, 0));

      // 完了を通知（これにより Upload の内部状態が 'done' に切り替わる）
      if (onProgress) onProgress({ percent: 100 }, file);
      if (onSuccess) onSuccess('ok', file);
    } catch (err) {
      // onUpload 内で例外が発生したら error にする
      if (onError) onError(err as Error);
    }
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>{uploadText}</div>
    </div>
  );

  return (
    <>
      <Upload
        action={action}
        {...props}
        customRequest={customUpload}
        listType="picture-card"
        fileList={fileList}
        onPreview={handlePreview}
        onChange={handleChange}
        className={styles.uploadImageBox}
      >
        {fileList && fileList.length >= maxCount ? null : uploadButton}
      </Upload>

      <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
        <img alt="example" style={{ width: '100%' }} src={previewImage} />
      </Modal>
    </>
  );
};

export default App;
